var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 358.7 344",
    style: {
      enableBackground: "new 0 0 358.7 344"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0F0F0F;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#0F0F0F;stroke-miterlimit:10;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9893 -0.1461 0.1461 0.9893 -25.3149 12.5456)",
    className: "st0",
    cx: 72.8,
    cy: 178.6,
    rx: 39.8,
    ry: 127.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109,284c-15.4-19.6-29.8-60-36.9-107.9c-6.8-46-5.1-87.4,3.1-111.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9893 -0.1461 0.1461 0.9893 -24.8028 13.0743)",
    className: "st0",
    cx: 76.6,
    cy: 175.4,
    rx: 44.1,
    ry: 146.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,320.2l62.4-9.7c19.5-2.9,30.5-70.1,18.9-148.5S138,24.2,118.6,27l-63.4,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.1,268c-0.4,2.4-39.5,20.2-59.1,9.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "95.8,76.2 154,68.8 171.7,122.5 113.3,131.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.3,296.2c-18.1,1.7-37.2-44-42.6-102.3c-5.4-58.2,5-106.9,23.1-108.8s37.3,44,42.6,102.2 S271.5,294.4,253.3,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.8,284c-11.7-17.1-22-53.4-25.6-92.8c-3.6-38.8,1.4-75.7,9.5-94.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,309.1c-20.1,2-41.4-50.5-47.7-117.3c-6.2-66.8,5.1-122.5,25.2-124.5c20.1-2,41.4,50.5,47.7,117.3 S278.3,307.1,258.1,309.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,309.1l52.1-5.5c16.2-1.6,28.4-57,22.4-122.3s-28-116-44.3-114.4l-52.6,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.5,272.6c0,0-25.5,9.6-48-0.5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBand);
export default __webpack_public_path__ + "static/media/band.677b35ef369ffd694eed0085dba23fd7.svg";
export { ForwardRef as ReactComponent };